import React from 'react';
import { messageFormat } from '@clubmed/utils';
import { OVER_BOT } from 'Components/frameworks/portal/Portal.constants';
import { MEDIA_TYPES_NAMES } from 'Components/utils/medias/medias';
import { t } from 'Src/i18n';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { classnames } from 'Utils/classnames/classnames.utils';
import ratioUtils from 'Components/utils/ratios/ratios.utils';
import { Multimedia } from 'Components/widgets/multimedia/Multimedia';
type Props = {
  accommodationName: string;
  className?: string;
  floorPlans?: Array<string>;
  isExclusiveCollection?: boolean;
  isCabin?: boolean;
  images: Array<{
    alt?: string;
    src: string;
  }>;
  streetView?: StreetView;
};
export const AccommodationRoomSlideshow = ({
  accommodationName,
  className,
  floorPlans = [],
  isExclusiveCollection = false,
  isCabin = false,
  images = [],
  streetView,
}: Props) => {
  const { trackClickEvent } = useTrackEvent();

  if (!images?.length) {
    return null;
  }

  const closeLabel = t('common.close');
  const nextLabel = t('common.next');
  const previousLabel = t('common.previous');
  const roomGalleryLabel = t('common.galleries.roomGallery');
  const galleryLabel =
    accommodationName && roomGalleryLabel
      ? messageFormat(roomGalleryLabel).format({
          roomName: accommodationName,
        })
      : t('common.galleries.gallery');
  const medias = {
    photos: images.map(({ src }) => ({
      url: src,
    })),
    streetViews: streetView ? [streetView] : undefined,
    floorPlans: floorPlans.map((plan) => ({
      url: plan,
    })),
  };
  return (
    <Multimedia
      className={classnames(className, 'flex flex-col justify-center')}
      closeLabel={closeLabel}
      descriptionLabels={{
        photos: '',
        streetViews: t('common.view360Disclaimer'),
        floorPlans: t('common.roomPlan.disclaimer'),
      }}
      galleryLabel={galleryLabel}
      hasImageSlideShowLauncher
      isExclusiveCollection={isExclusiveCollection}
      labels={{
        floorPlans: isCabin ? t('common.roomPlan.titleCruise') : t('common.roomPlan.title'),
        photos: t('common.photoTitle'),
        streetViews: '',
      }}
      launcherPictureAltLabel={t('common.galleries.openProductSlideShowGalleryAt', {
        productName: accommodationName,
      })}
      medias={medias}
      nextLabel={nextLabel}
      onClickMediaBtn={(type) =>
        trackClickEvent(TRACK_EVENT_NAMES.CLICK_ACCOMMODATION, {
          detail_click: MEDIA_TYPES_NAMES[type],
        })
      }
      openGalleryLabel={t('common.galleries.openSlideShowGallery')}
      pictureAltLabel={t('common.galleries.productPictureItem', {
        productName: accommodationName,
      })}
      portalName={OVER_BOT}
      previousLabel={previousLabel}
      ratioKey={ratioUtils.L}
      theme="accommodation"
    />
  );
};
